import { dbService } from './db';

export const userService = {
    login, logout, getSession, isSalesUser, createSalesSession, clearCaches
};

async function login(username, password) {
    let db = await dbService.createDB();
    let user = await db.getFromIndex("users", "usernameIndex", username.trim().toLowerCase());
    if(user != null){
        let verification = await verifyExistingPassword(password, user.password_salt, user.password_hash, user.password_iterations, "SHA-1", "256");
        if (verification.isValid) {
            await createSession(db, user);
            return user;
        }
    }
    return null;
}

async function verifyExistingPassword(password, storedSalt, storedHash, storedIterations, hashAlgorithm, keySize) {
    try {
        const saltBuffer = Uint8Array.from(atob(storedSalt), c => c.charCodeAt(0));
        const passwordBuffer = new TextEncoder().encode(password);
        const key = await window.crypto.subtle.importKey(
            'raw', passwordBuffer, 'PBKDF2', false, ['deriveBits']
        );
        const derivedBits = await window.crypto.subtle.deriveBits(
            {
                name: 'PBKDF2',
                salt: saltBuffer,
                iterations: storedIterations,
                hash: hashAlgorithm
            },
            key,
            keySize * 8
        );
        const computedHash = btoa(String.fromCharCode(...new Uint8Array(derivedBits)));
        return {
            isValid: computedHash === storedHash,
            computedHash: computedHash
        };
    } catch (error) {
        throw error;
    }
}

function clearCaches() {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    const messageChannel = new MessageChannel();

    messageChannel.port1.onmessage = (event) => {
      if (event.data && event.data.success) {
        console.log('[React] Caches cleared by Service Worker');
        alert('All caches cleared!');
      } else {
        console.error('[React] Failed to clear caches');
      }
    };

    navigator.serviceWorker.controller.postMessage(
      { type: 'CLEAR_ALL_CACHES' },
      [messageChannel.port2]
    );
  } else {
    console.warn('No active service worker found.');
  }
}


async function createSession(db, user) {
    await db.clear("session");
    await db.put("session", user);
}

async function getSession() {
    let db = await dbService.createDB();
    return (await db.getAll("session"))[0];
}


async function logout() {
    let db = await dbService.createDB();
    await db.clear("session");    
}

async function isSalesUser(activeAccount) {
    let db = await dbService.createDB();
    let user = await db.getFromIndex("users", "emailIndex", activeAccount.username?.trim()?.toLowerCase());
    if(user) {
        return true;
    }
    return false;
}

async function createSalesSession(activeAccount) {
    let db = await dbService.createDB();
    let user = await db.getFromIndex("users", "emailIndex", activeAccount.username.trim().toLowerCase());
    await db.clear("session");
    await db.put("session", user);
}